import React from 'react'
import { Styling } from '../Styling'

export const CollapseContent: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return <Styling padding="1.5rem 0 0.5rem 0">{children}</Styling>
}
